// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
    size: A4;
    margin: 0;
}

/* ========== INVOICE CONTAINER ========== */
.invoice-container {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 40px;
    background: white;
    font-family: 'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px;
    line-height: 1.6;
    color: #333333;
}

.invoice-container p{
    margin: 0;
}

/* ========== HEADER SECTION ========== */
.invoice-title {
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
    letter-spacing: 0.5px;
}

.invoice-header {
    margin-bottom: 30px;
}

.header-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: flex-start;
}

.bill-from-section h4 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 6px;
    color: #000;
}

.bill-from-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 14px;
}

.bill-from-content .company-name {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    margin: 0;
}

.bill-from-content .address {
    white-space: pre-wrap;
    word-break: break-word;
}

.bill-from-content .email a {
    color: inherit;
    text-decoration: none;
}

.bill-from-content .email a:hover {
    text-decoration: underline;
}

/* Logo Section */
.logo-section {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo-image {
    width: 200px;
    max-height: 80px;
    object-fit: contain;
}

.logo-text {
    font-size: 12px;
    text-align: center;
    color: #666;
    margin-top: -10px;
}

/* ========== INVOICE DETAILS SECTION ========== */
.invoice-details-section {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 30px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    align-items: flex-start;
}

.details-left h4,
.details-right h4 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 0px;
    color: #000;
}

.bill-to-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 12px;
}

.bill-to-content .name {
    font-weight: 600;
    color: #333333;
    font-size: 14px;
}

.bill-to-content .email {
    color: #666;
}

/* Divider */
.divider-vertical {
    width: 1px;
    height: 150px;
    background: #d4d4d4;
}

.divider-horizontal {
    height: 1px;
    background: #d4d4d4;
    margin: 20px 0;
}

/* Details Right */
.details-right {
    display: flex;
    flex-direction: column;
    gap: 0;
    margin-top: 20px;
}

.detail-row {
    display: grid;
    grid-template-columns: 140px 1fr;
    font-size: 14px;
}

.detail-row .label {
    font-weight: 700;
    color: #000;
    padding-right: 8px;
}

.detail-row .value {
    color: #333333;
}

.declaration {
    font-size: 14px;
    color: #666;
    line-height: 1.4;
    max-width: 280px;
}

/* ========== SHIPPING SECTION ========== */
.shipping-section {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 30px;
    margin-bottom: 15px;
    padding-bottom: 20px;
}

.shipping-left h4,
.shipping-right h4 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 12px;
    color: #000;
}

.shipping-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 14px;
}

.shipping-content .name {
    font-weight: 600;
    color: #333333;
    font-size: 14px;
}

.divider-vertical-shipping {
    width: 1px;
    background: #d4d4d4;
}

/* ========== TABLE SECTION ========== */
.table-container {
    margin-bottom: 15px;
    overflow-x: auto;
}

.invoice-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.invoice-table thead {
    background: #d0d0d0;
}

.invoice-table th {
    padding: 6px;
    text-align: left;
    font-weight: 700;
    color: #000;
    border: none;
    white-space: nowrap;
}

.invoice-table th.col-sno,
.invoice-table th.col-qty,
.invoice-table th.col-hsn,
.invoice-table th.col-units,
.invoice-table th.col-rate {
    text-align: left;
}

.invoice-table th.col-amount {
    text-align: right;
}

.invoice-table td {
    padding: 6px;
    border-bottom: 1px solid #d0d0d0;
    color: #333333;
    font-size: 12px;
}

.invoice-table tbody tr:last-child td {
    border-bottom: 1px solid #d0d0d0;
}

.invoice-table .col-sno {
    width: 50px;
    text-align: left;
}

.invoice-table .col-items {
    width: auto;
    min-width: 150px;
    word-break: break-word;
}

.invoice-table .col-hsn {
    width: 80px;
    text-align: left;
}

.invoice-table .col-qty {
    width: 60px;
    text-align: left;
}

.invoice-table .col-units {
    width: 80px;
    text-align: left;
}

.invoice-table .col-rate {
    width: 100px;
    text-align: left;
}

.invoice-table .col-amount {
    width: 100px;
    text-align: right;
}

/* ========== SUMMARY SECTION ========== */
.summary-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    margin-bottom: 15px;
    padding: 20px 0;
}

.summary-left {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
}

.amount-in-words {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.amount-in-words .label {
    font-weight: 700;
    font-size: 14px;
    color: #000;
}

.amount-in-words .value {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    max-width: 350px;
}

.summary-right {
    display: flex;
    justify-content: flex-end;
}

.tax-summary {
    width: 100%;
    max-width: 250px;
    display: flex;
    flex-direction: column;
    gap: 0;
}

.summary-row {
    display: grid;
    grid-template-columns: 1fr auto;
    padding-bottom: 2px;
    font-size: 14px;
}

.summary-row .label {
    font-weight: 600;
    color: #000;
    text-align: left;
}

.summary-row .value {
    text-align: right;
    color: #333333;
    min-width: 80px;
}

.summary-row.total {
    background: #d0d0d0;
    border: none;
    padding: 5px;
    font-weight: 700;
    font-size: 14px;
    margin-top: 5px
}

.summary-row.total .label {
    font-weight: 700;
}

.summary-row.total .value {
    font-weight: 700;
    font-size: 14px;
}

/* ========== BANK DETAILS ========== */
.bank-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    margin-bottom: 15px;
    padding: 20px 0;
}

.bank-details h4 {
    grid-column: 1;
    font-size: 16px;
    font-weight: 700;
    color: #000;
    margin-bottom: 0;
}

.stamp-image {
    border-bottom: 1px solid #d4d4d4;
    padding-bottom: 5px;
    text-align: center
}

.stamp-image img{
    max-width: 100px;
}

.bank-info {
    grid-column: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 14px;
    color: #333333;
}

.authorized-signature {
    grid-column: 2;
    justify-self: end;
    text-align: right;
}

.authorized-signature p {
    font-size: 14px;
    color: #000;
    font-weight: 600;
}

/* ========== TERMS & CONDITIONS ========== */
.terms-section {
    margin-bottom: 30px;
    padding: 20px 0;
    break-inside: avoid;
    page-break-inside: avoid;
}

.terms-section h4 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
    color: #000;
}

.terms-list {
    margin: 0;
    /* padding-left: 20px; */
    font-size: 14px;
    color: #333333;
    padding: 0;
}

.terms-list li {
    list-style: decimal;
    margin: 0;
    padding: 0;
}

/* Declaration Section */
.declaration-section {
    padding: 20px 0;
    font-size: 12px;
    line-height: 1.6;
    color: #333333;
}`, "",{"version":3,"sources":["webpack://./src/components/Invoice/InvoiceTemplate.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA,4CAA4C;AAC5C;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,mFAAmF;IACnF,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA,yCAAyC;AACzC;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,mCAAmC;IACnC,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA,YAAY;AACZ;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,mCAAmC;IACnC,SAAS;IACT,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;;;;IAKI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":["@page {\n    size: A4;\n    margin: 0;\n}\n\n/* ========== INVOICE CONTAINER ========== */\n.invoice-container {\n    width: 100%;\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 40px;\n    background: white;\n    font-family: 'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n    font-size: 14px;\n    line-height: 1.6;\n    color: #333333;\n}\n\n.invoice-container p{\n    margin: 0;\n}\n\n/* ========== HEADER SECTION ========== */\n.invoice-title {\n    font-size: 28px;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 30px;\n    letter-spacing: 0.5px;\n}\n\n.invoice-header {\n    margin-bottom: 30px;\n}\n\n.header-content {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 40px;\n    align-items: flex-start;\n}\n\n.bill-from-section h4 {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 6px;\n    color: #000;\n}\n\n.bill-from-content {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    font-size: 14px;\n}\n\n.bill-from-content .company-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: #333333;\n    margin: 0;\n}\n\n.bill-from-content .address {\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.bill-from-content .email a {\n    color: inherit;\n    text-decoration: none;\n}\n\n.bill-from-content .email a:hover {\n    text-decoration: underline;\n}\n\n/* Logo Section */\n.logo-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.logo-image {\n    width: 200px;\n    max-height: 80px;\n    object-fit: contain;\n}\n\n.logo-text {\n    font-size: 12px;\n    text-align: center;\n    color: #666;\n    margin-top: -10px;\n}\n\n/* ========== INVOICE DETAILS SECTION ========== */\n.invoice-details-section {\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    gap: 30px;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    align-items: flex-start;\n}\n\n.details-left h4,\n.details-right h4 {\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 0px;\n    color: #000;\n}\n\n.bill-to-content {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    font-size: 12px;\n}\n\n.bill-to-content .name {\n    font-weight: 600;\n    color: #333333;\n    font-size: 14px;\n}\n\n.bill-to-content .email {\n    color: #666;\n}\n\n/* Divider */\n.divider-vertical {\n    width: 1px;\n    height: 150px;\n    background: #d4d4d4;\n}\n\n.divider-horizontal {\n    height: 1px;\n    background: #d4d4d4;\n    margin: 20px 0;\n}\n\n/* Details Right */\n.details-right {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    margin-top: 20px;\n}\n\n.detail-row {\n    display: grid;\n    grid-template-columns: 140px 1fr;\n    font-size: 14px;\n}\n\n.detail-row .label {\n    font-weight: 700;\n    color: #000;\n    padding-right: 8px;\n}\n\n.detail-row .value {\n    color: #333333;\n}\n\n.declaration {\n    font-size: 14px;\n    color: #666;\n    line-height: 1.4;\n    max-width: 280px;\n}\n\n/* ========== SHIPPING SECTION ========== */\n.shipping-section {\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    gap: 30px;\n    margin-bottom: 15px;\n    padding-bottom: 20px;\n}\n\n.shipping-left h4,\n.shipping-right h4 {\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 12px;\n    color: #000;\n}\n\n.shipping-content {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    font-size: 14px;\n}\n\n.shipping-content .name {\n    font-weight: 600;\n    color: #333333;\n    font-size: 14px;\n}\n\n.divider-vertical-shipping {\n    width: 1px;\n    background: #d4d4d4;\n}\n\n/* ========== TABLE SECTION ========== */\n.table-container {\n    margin-bottom: 15px;\n    overflow-x: auto;\n}\n\n.invoice-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n}\n\n.invoice-table thead {\n    background: #d0d0d0;\n}\n\n.invoice-table th {\n    padding: 6px;\n    text-align: left;\n    font-weight: 700;\n    color: #000;\n    border: none;\n    white-space: nowrap;\n}\n\n.invoice-table th.col-sno,\n.invoice-table th.col-qty,\n.invoice-table th.col-hsn,\n.invoice-table th.col-units,\n.invoice-table th.col-rate {\n    text-align: left;\n}\n\n.invoice-table th.col-amount {\n    text-align: right;\n}\n\n.invoice-table td {\n    padding: 6px;\n    border-bottom: 1px solid #d0d0d0;\n    color: #333333;\n    font-size: 12px;\n}\n\n.invoice-table tbody tr:last-child td {\n    border-bottom: 1px solid #d0d0d0;\n}\n\n.invoice-table .col-sno {\n    width: 50px;\n    text-align: left;\n}\n\n.invoice-table .col-items {\n    width: auto;\n    min-width: 150px;\n    word-break: break-word;\n}\n\n.invoice-table .col-hsn {\n    width: 80px;\n    text-align: left;\n}\n\n.invoice-table .col-qty {\n    width: 60px;\n    text-align: left;\n}\n\n.invoice-table .col-units {\n    width: 80px;\n    text-align: left;\n}\n\n.invoice-table .col-rate {\n    width: 100px;\n    text-align: left;\n}\n\n.invoice-table .col-amount {\n    width: 100px;\n    text-align: right;\n}\n\n/* ========== SUMMARY SECTION ========== */\n.summary-section {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 40px;\n    margin-bottom: 15px;\n    padding: 20px 0;\n}\n\n.summary-left {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n.amount-in-words {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.amount-in-words .label {\n    font-weight: 700;\n    font-size: 14px;\n    color: #000;\n}\n\n.amount-in-words .value {\n    font-size: 14px;\n    color: #666;\n    line-height: 1.5;\n    max-width: 350px;\n}\n\n.summary-right {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.tax-summary {\n    width: 100%;\n    max-width: 250px;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.summary-row {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    padding-bottom: 2px;\n    font-size: 14px;\n}\n\n.summary-row .label {\n    font-weight: 600;\n    color: #000;\n    text-align: left;\n}\n\n.summary-row .value {\n    text-align: right;\n    color: #333333;\n    min-width: 80px;\n}\n\n.summary-row.total {\n    background: #d0d0d0;\n    border: none;\n    padding: 5px;\n    font-weight: 700;\n    font-size: 14px;\n    margin-top: 5px\n}\n\n.summary-row.total .label {\n    font-weight: 700;\n}\n\n.summary-row.total .value {\n    font-weight: 700;\n    font-size: 14px;\n}\n\n/* ========== BANK DETAILS ========== */\n.bank-details {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 40px;\n    margin-bottom: 15px;\n    padding: 20px 0;\n}\n\n.bank-details h4 {\n    grid-column: 1;\n    font-size: 16px;\n    font-weight: 700;\n    color: #000;\n    margin-bottom: 0;\n}\n\n.stamp-image {\n    border-bottom: 1px solid #d4d4d4;\n    padding-bottom: 5px;\n    text-align: center\n}\n\n.stamp-image img{\n    max-width: 100px;\n}\n\n.bank-info {\n    grid-column: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    font-size: 14px;\n    color: #333333;\n}\n\n.authorized-signature {\n    grid-column: 2;\n    justify-self: end;\n    text-align: right;\n}\n\n.authorized-signature p {\n    font-size: 14px;\n    color: #000;\n    font-weight: 600;\n}\n\n/* ========== TERMS & CONDITIONS ========== */\n.terms-section {\n    margin-bottom: 30px;\n    padding: 20px 0;\n    break-inside: avoid;\n    page-break-inside: avoid;\n}\n\n.terms-section h4 {\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 10px;\n    color: #000;\n}\n\n.terms-list {\n    margin: 0;\n    /* padding-left: 20px; */\n    font-size: 14px;\n    color: #333333;\n    padding: 0;\n}\n\n.terms-list li {\n    list-style: decimal;\n    margin: 0;\n    padding: 0;\n}\n\n/* Declaration Section */\n.declaration-section {\n    padding: 20px 0;\n    font-size: 12px;\n    line-height: 1.6;\n    color: #333333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
